import React from 'react';

export type TriggersObject = Record<string, any>;

export const TriggersContext = React.createContext<TriggersObject>({});

type TriggersProviderProps = {
  value: TriggersObject;
  children: React.ReactNode;
};

export const TriggersProvider: React.FC<TriggersProviderProps> = ({ value, children }) => {
  return (
    <TriggersContext.Provider value={value}>
      {children}
    </TriggersContext.Provider>
  );
};

export function useTriggers(): TriggersObject {
  return React.useContext(TriggersContext);
}


